import auth from '@/components/auth/AuthCheck.js';
import utils from '@/components/utils/Utils.js';
import jwt_decode from 'jwt-decode';
import store from '@/store/Store.js';

export default {

	checkAuth(context) {
	    let jwt = localStorage.getItem('id_token');
	    if(!jwt) {
	    	console.log('No Token - login required');
	        // auth.logout(context); // not needed because we set a false flag in the return to check in main.js BeforeEach
	        return false
	    } else {
	      let decoded = jwt_decode(jwt);
	      if (decoded.exp < Date.now() / 1000) {
	    	console.log('Token Expired - now will be destroyed');
	      	localStorage.removeItem('id_token'); // Destoy the expired token
	        return false;
	      }else{
	        return true;
	      }
	    }
	},


    // Check if initial corporate user has completed all steps
    setupStatus: function(router) {
			// console.log('Check user setup status');
			const me = this;
			//console.log(store.billing_id);
			var jwt = utils.decodejwt(me, 'login'); 
			// if (store.billing_id === undefined || store.billing_id === null) {
			// 	var token = null;
			// } else {
			// 	var token = store.billing_id; 				
			// }
			var token = jwt.billing_id;
			var corpId = jwt.corporateinfo;
			var storeId = jwt.storeinfo;
			//console.log('Vars setup', token,corpId,storeId);			
			// Corporate user redirect. NOTE: have to use NULL on billing!
			if (token === null && corpId == 1) {
					//router go to page and activate tab
					console.log('Corporate Not setup!');
					if (router.currentRoute.name != 'CorporateSetup') {
						console.log('No path match so redirecting');
						router.push({name: 'CorporateSetup'});				
						console.log('Full path', router.currentRoute.name);	
					}					
					//return false;
			}
			// Store user redirect NOTE: have to use NULL on billing!
			else if (token === null && corpId !== 1) {
				console.log('Store Not setup!');
				if (router.currentRoute.name != 'SiteSetup') {
					console.log('No path match so redirecting');
					router.push({name: 'SiteSetup'});				
					console.log('Full path', router.currentRoute.name);	
				}			
			} else {
					//return true;
			}
	},




}


// WEBPACK FOOTER //
// ./src/components/auth/checkJWT.js